import { Box, Drawer, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Divider } from "@mui/material";
import { IconButton } from "@mui/material";
import { ArrowForwardIosRounded } from "@mui/icons-material";

const CustomDrawer = function (props) {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    width = 350,
    height = "calc(100vh - 85px)",
    open,
    content,
    back = false,
    handleBackClick,
    sx,
    title,
    top = "70px",
  } = props;

  return (
    <Drawer
      sx={{
        flexShrink: 0,
        width: width,
        // width: '23vw',
        "& .MuiDrawer-paper": {
          // width: '97vw',
          height: height,
          borderRadius: "10px",
          border: 1,
          borderColor: "divider",
          mt: 0,
          mr: 0,
          top: 0,
          position: "relative",
          overflowY: "hidden",
          [theme.breakpoints.down("md")]: {
            backgroundColor: "#fff",
            position: "fixed",
            top: top,
            left: 0,
            right: 0,
            bottom: 0,
            m: 1,
          },
        },
      }}
      variant='persistent'
      anchor='right'
      open={open}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      hideBackdrop={true}
    >
      <Stack direction='row' alignItems='center'>
        <IconButton
          {...(open && { className: "backButton" })}
          onClick={handleBackClick}
          sx={{
            display: "flex",
            // [theme.breakpoints.down('lg')]: {
            //   display: 'flex',
            // },
          }}
        >
          <ArrowForwardIosRounded fontSize='small' />
        </IconButton>
        <Typography variant='h6' padding={1} fontWeight={"bold"} ml={1} fontSize={isSm ? "16px" : "inherit"}>
          {title}
        </Typography>
      </Stack>
      <Divider />
      <Box sx={{ p: 0, display: "grid", height: "100%" }}>{content}</Box>
    </Drawer>
  );
};

export default CustomDrawer;
